import type { Category } from '~~/types/commercetools';
import { convertCommerceToolsCategories } from '~~/helpers/typesense/convertCommerceToolsCategories';
import { extractChildCategories } from '~~/helpers/category/categoriesTree';
import getBreadcrumbsList from '~~/helpers/category/getBreadcrumbsList';
import type { CategoryTree } from '~~/types/category/CategoryTree';

export const getTypesenseCategoryFilter = ({ categorySlug, categories, categoryTree }:
  { categorySlug: string, categories: Category[], categoryTree: CategoryTree },
): string => {

  const childCategories = extractChildCategories(categories) || undefined;
  const breadcrumbsList = getBreadcrumbsList(
    childCategories,
    categorySlug,
  );

  return convertCommerceToolsCategories(breadcrumbsList, categoryTree);

};
